import { AccordionSummary, Box, makeStyles } from '@material-ui/core';
import React from 'react';

import { useCustomTheme } from '../../../../hooks/useCustomTheme';

export function AccordionStyledSummary(props: { children: React.ReactNode; expanded: boolean; hideIcon?: boolean }) {
  const { palette, customBorderRadius } = useCustomTheme();

  const useStyles = makeStyles({
    root: {
      '&:hover': { background: palette.grey[50], cursor: 'unset !important' },
      minHeight: '0 !important',
      borderRadius: customBorderRadius.paper,
      '& .MuiAccordionSummary-content': {
        margin: '0 !important',
        padding: '4px 8px 4px 14px',
        display: 'inline-flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        width: '100%',
      },
    },
  });

  return (
    <AccordionSummary
      className={useStyles().root}
      style={{ padding: 0, minHeight: '0 !important', background: 'inherit' }}
    >
      {props.children}
      {!props.hideIcon && (
        <Box display={'flex'} justifyContent={'center'} flexDirection={'column'} ml={2}>
          <i className="material-icons-outlined" style={{ fontSize: '16px' }}>
            {props.expanded ? 'expand_less' : 'expand_more'}
          </i>
        </Box>
      )}
    </AccordionSummary>
  );
}
